var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9144 -0.000106399C46.4975 -0.037311 60.0334 13.4642 59.9999 30.0054C59.9665 46.6098 46.572 59.9551 29.8995 59.9998C13.5024 60.0407 -0.0297165 46.4573 4.90109e-05 29.9868C0.0298146 13.4531 13.4131 0.0370982 29.9144 -0.000106399ZM55.9593 29.9794C55.963 15.7635 44.2614 4.0552 30.026 4.03659C15.7907 4.01799 4.12258 15.6407 4.04072 29.9236C3.95515 44.1878 15.7535 55.9928 30.0632 55.9594C44.2949 55.9259 55.9555 44.2287 55.9593 29.9794Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3314 53.1915C23.1802 53.1357 17.4392 50.5425 12.7214 45.5422C11.754 44.5154 11.6796 43.5964 12.2451 42.3947C14.1501 38.3655 17.3238 36.1555 21.7478 36.0513C27.2655 35.9211 32.7908 35.962 38.3086 36.0402C42.6953 36.1034 46.3973 38.8305 47.9079 42.7854C48.2874 43.7787 48.2056 44.4819 47.4763 45.2855C42.8032 50.4458 37.0138 53.0762 30.3314 53.1915Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0976 23.1636C40.1014 28.8336 35.6179 33.3242 29.955 33.3205C24.3479 33.3167 19.8608 28.7554 19.8868 23.0855C19.9129 17.5308 24.3777 13.0551 29.9364 13.0067C35.5286 12.9584 40.0939 17.5196 40.0976 23.1636Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUser);
export default __webpack_public_path__ + "static/media/default-user.98a1c4bba418761a8feb2a80be72991b.svg";
export { ForwardRef as ReactComponent };